module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/338628/target03-967aa2b74348d47b8370e0af4f564f56.png";